module.exports = __webpack_public_path__ + "audio-c16c3d40d5ec.m4a";